import { createGlobalStyle, css } from 'styled-components'
import colors from 'components/utils/colors'
import OpenSansLight from 'assets/fonts/Open-Sans-light.woff'
import OpenSansBold from 'assets/fonts/Open-Sans-bold.woff'
import OpenSansRegular from 'assets/fonts/Open-Sans-regular.woff'
import OpenSansSemiBold from 'assets/fonts/Open-Sans-semibold.woff'
import ExoLight from 'assets/fonts/exo-v15-latin-300.woff2'
import ExoRegular from 'assets/fonts/exo-v15-latin-regular.woff2'
import ExoMedium from 'assets/fonts/exo-v15-latin-500.woff2'
import ExoSemiBold from 'assets/fonts/exo-v15-latin-600.woff2'
import Icomoon from 'assets/fonts/icomoon.ttf'

const globalWrappers = css`
  body {
    font-family: 'Open Sans';
    line-height: 1;
    color: ${colors.secondary40};
  }

  input, select, button {
    font-family: 'Open Sans';
  }

  #application-content {
    height: 100vh;
    display: flex;
  }

  a {
    text-decoration: none;
    outline: none;
    color: ${colors.primary35};
    &:hover,
    &:focus-visible,
    &:focus-visible > i,
    &:focus-visible > i:before {
      color: ${colors.primary40};
    }

    &:active {
      color: ${colors.primary35};
    }
  }
`

const resetStyles = css`
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym,
address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var,
b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead,
tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav,
output, ruby, section, summary, time, mark, audio, video, textarea, input {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
  display: block;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after, q:before, q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

html {
  min-height: 100%;
}
`

const fonts = css`
@font-face {
  font-family: 'icomoon';
  font-style: normal;
  font-weight: normal;
  font-display: block;
  src: url('${Icomoon}');
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local('Open Sans'), local('Open-Sans-regular'), url('${OpenSansRegular}');
}

@font-face {
  font-family: 'Open Sans';
  font-weight: 600;
  font-display: swap;
  src: local('Open Sans Semibold'), local('Open-Sans-Semibold'), url('${OpenSansSemiBold}');
}

@font-face {
  font-family: 'Open Sans';
  font-weight: bold;
  font-display: swap;
  src: local('Open Sans Bold'), local('Open-Sans-Bold'), url('${OpenSansBold}');
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local('Open Sans Light'), local('Open-Sans-Light'), url('${OpenSansLight}');
}

@font-face {
  font-family: Exo;
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  descent-override: 28%;
  src: local('Exo'), url('${ExoLight}');
}

@font-face {
  font-family: Exo;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  descent-override: 28%;
  src: local('Exo'), url('${ExoRegular}');
}

@font-face {
  font-family: Exo;
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  descent-override: 28%;
  src: local('Exo'), url('${ExoMedium}');
}

@font-face {
  font-family: Exo;
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  descent-override: 28%;
  src: local('Exo'), url('${ExoSemiBold}');
}
`

// disabled as it is too slow
// const icons = createIcons()
const icons = null

const GlobalStyle = createGlobalStyle`
  ${resetStyles}
  ${fonts}
  ${globalWrappers}
  ${icons}
`

export default GlobalStyle
